var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 20,
    viewBox: "0 0 26 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M23.4,20H2.6A2.555,2.555,0,0,1,0,17.5l.013-15A2.548,2.548,0,0,1,2.6,0H23.4A2.555,2.555,0,0,1,26,2.5v15A2.555,2.555,0,0,1,23.4,20ZM3,2V4.571L13.5,11,24,4.571V2L13.5,8.429Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmail);
export default __webpack_public_path__ + "static/media/icon-email.5c3b8b2404f6b66e2d7563c08892b8db.svg";
export { ForwardRef as ReactComponent };